import { render, staticRenderFns } from "./Benutzerautorisierung.vue?vue&type=template&id=df364caa&scoped=true&"
import script from "./Benutzerautorisierung.vue?vue&type=script&lang=js&"
export * from "./Benutzerautorisierung.vue?vue&type=script&lang=js&"
import style0 from "./Benutzerautorisierung.vue?vue&type=style&index=0&id=df364caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df364caa",
  null
  
)

export default component.exports